import { AsyncPipe, CurrencyPipe, DatePipe, UpperCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { TaxFacade } from '@zero/self-service/domain';
import { IconComponent } from '@zero/shared/ui-web-design-system';
import { environment } from 'environments/environment';
import { Observable, filter, map } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { SwitchChangeFsaComponent } from './switch-change-fsa/switch-change-fsa.component';
import { VvtResetComponent } from './vvt-reset/vvt-reset.component';

@Component({
  selector: 'self-service-tax',
  templateUrl: './tax.component.html',
  imports: [SwitchChangeFsaComponent, VvtResetComponent, AsyncPipe, CurrencyPipe, DatePipe, TranslocoPipe, IconComponent, UpperCasePipe],
})
export class TaxComponent extends BaseComponent {
  public readonly resetVvtAllowed$: Observable<boolean>;
  public activeYear: number;
  public readonly currentYear = new Date().getFullYear();
  public readonly shouldDisplayNotAvailableHint = environment.disableTax;
  public readonly taxFacade = inject(TaxFacade);

  constructor() {
    super();
    this.activeYear = this.currentYear;
    this.resetVvtAllowed$ = this.customerStateFacade.customerBaseData$.pipe(
      filter((cbd) => !!cbd),
      map(({ taxCountry }) => {
        return this.#isTaxCountryGermany(taxCountry);
      }),
      takeUntilDestroyed(this.destroyRef),
    );
  }

  public toggleTax = (): void => {
    this.showMe = !this.showMe;
    this.showMe && this.taxFacade.loadTax();
  };

  #isTaxCountryGermany = (taxCountry: string): boolean => taxCountry === '004';
}
